<template>
	<el-dialog :title="title" :visible.sync="dialogVisible" width="550px" :before-close="handleClose" class="rePassword" :close-on-click-modal="false">
		<Verify :mode="'pop'" :captchaType="'blockPuzzle'" :imgSize="{ width: '330px', height: '155px' }" ref="verifyForBack" @success="onSuccess"></Verify>

		<div class="rePasswordForm">
			<el-row v-show="pageInx === 1" class="pageInx1">
				<el-form ref="reform" :model="reform" :rules="rules">
					<el-form-item prop="username">
						<el-input v-model.trim="reform.username" placeholder="请输入登录账号"><i slot="prefix" class="el-input__icon el-icon-user"></i></el-input>
					</el-form-item>
					<!-- 	<el-form-item>
						<slide-verification ref="slideVerification" :code-box="reCodeBox"></slide-verification>
					</el-form-item> -->
					<el-row>
						<el-button v-if="!verifyData.success" type="primary" plain class="validate" @click="showVerify">请点击完成安全验证</el-button>
						<el-button v-else type="success" plain class="validate" icon="el-icon-check">校验通过</el-button>
						<!--						<el-button type="primary" plain class="validate" @click="showVerify">请点击完成安全验证</el-button>-->
					</el-row>
				</el-form>
			</el-row>
			<el-row v-show="pageInx === 2" class="pageInx2">
				<div class="phoneinfo">
					<span class="phonenums">当前手机号码：</span>
					{{ userMobile }}
				</div>
				<div class="lines"></div>
				<el-form ref="reform2" :model="reform2" :rules="rules">
					<div class="inputrow">
						<el-form-item><el-input v-model.trim="reform2.erifCode" placeholder="请输入验证码"></el-input></el-form-item>
						<div class="getVali curpointer"><img :src="imgCodeUrl" alt="" @click="refreshCaptcha" /></div>
					</div>
					<div class="inputrow">
						<el-form-item prop="valid"><el-input v-model.trim="reform2.valid" placeholder="请输入验证码"></el-input></el-form-item>
						<div class="getVali curpointer" v-show="canClick" @click.stop="getVali">点击获取验证码</div>
						<div class="timesout" v-show="!canClick">{{ second }}秒</div>
					</div>
				</el-form>
				<!-- <el-row>
					<div class="getVali curpointer">点击获取验证码</div>
				</el-row> -->
			</el-row>
			<el-row v-show="pageInx === 3" class="pageInx3">
				<el-form ref="reform3" :model="reform3" :rules="rules">
					<el-form-item prop="pass">
						<el-input
							v-model.trim="reform3.pass"
							show-password
							placeholder="密码由字母加数字组成，必须大于8位且小于20位"
							@input="reform3.pass = reform3.pass.replace(/\s+/g, '')"
						></el-input>
					</el-form-item>
					<el-form-item prop="checkPass">
						<el-input
							v-model.trim="reform3.checkPass"
							show-password
							placeholder="请确认输入新密码"
							@input="reform3.checkPass = reform3.checkPass.replace(/\s+/g, '')"
						></el-input>
					</el-form-item>
				</el-form>
			</el-row>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button type="primary" @click.stop="next" v-if="pageInx === 1 || pageInx === 2" class="btns btn-icon-flex">
				<!-- <img src="~@/assets/img/login/xiayibu.png" alt="" />
				 -->
				<i class="iconfont iconqueding btn-icon"></i>
				<span>下一步</span>
			</el-button>
			<el-button type="primary" v-if="pageInx === 3" class="btns btn-icon-flex" @click.stop="surefn">
				<!-- <img src="~@/assets/img/login/xiayibu.png" alt="" /> -->

				<i class="iconfont iconqueding btn-icon"></i>
				<span>确 定</span>
			</el-button>
			<div v-if="pageInx === 2" class="contact-number">
				手机号码换了？ 请联系：
				<span>17308491715</span>
			</div>
		</span>
	</el-dialog>
</template>

<script>
import loginApi from '@/api/login';
import SlideVerification from '@/components/SlideVerification.vue';
import Verify from '@/components/verifition/Verify';

export default {
	components: {
		SlideVerification,
		Verify
	},
	data() {
		var validatePass = (rule, value, callback) => {
			let reg = /^(?=.*[0-9])(?=.*[a-zA-Z])(.{8,})$/;
			let ch = /[\u4E00-\u9FA5\uF900-\uFA2D]/;
			let symbol = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/im;
			if (value === '') {
				callback(new Error('请输入密码'));
			} else if (!reg.test(value) || ch.test(value) || symbol.test(value)) {
				callback(new Error('密码由字母加数字组成，必须大于8位且小于20位'));
			} else {
				if (this.reform3.checkPass !== '') {
					this.$refs.reform3.validateField('checkPass');
				}
				callback();
			}
		};
		var validatePass2 = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请再次输入密码'));
			} else if (value !== this.reform3.pass) {
				callback(new Error('两次输入密码不一致!'));
			} else {
				callback();
			}
		};
		return {
			userMobile: '',
			stopClick: false,
			dialogVisible: false,
			reform: {
				username: ''
			},
			reform2: {
				valid: '',
				erifCode:''
			},
			imgCodeUrl: 'jiance/trial/getCaptchaImg?' + Math.ceil(Math.random() * 1000),
			reform3: {
				pass: '',
				checkPass: ''
			},
			reCodeBox: 'reCodeBox',
			title: '找回密码',
			title1: '找回密码',
			title2: '手机验证',
			title3: '确认修改密码',
			pageInx: 1,
			rules: {
				username: [
					{
						required: true,
						message: '请输入登录账号',
						trigger: 'blur'
					}
				],
				valid: [
					{
						required: true,
						message: '请输入验证码',
						trigger: 'blur'
					}
				],
				pass: [
					{
						required: true,
						message: '请输入密码',
						trigger: 'blur'
					},
					{
						min: 8,
						message: '长度在不小于8位',
						trigger: 'blur'
					},
					{
						validator: validatePass,
						trigger: 'blur'
					}
				],
				checkPass: [
					{
						validator: validatePass2,
						trigger: 'blur'
					}
				]
			},
			isvalidate1: false,
			isvalidate2: false,
			canClick: true,
			second: 60,
			timer: null,
			tips: '',
			verifyData: {
				success: false,
				captcha: ''
			}
		};
	},

	methods: {
		refreshCaptcha:function(){
			let num = Math.ceil(Math.random() * 1000);
			this.imgCodeUrl = 'jiance/trial/getCaptchaImg?' + num;
		},
		btKeyUp(e) {
			e.target.value = e.target.value.replace(/\s+/g, '');
		},
		showVerify() {
			this.$refs.verifyForBack.show();
		},
		onSuccess(event) {
			this.verifyData.success = true;
			this.verifyData.captcha = event.captchaVerification;
		},
		handleClose(done) {
			clearInterval(this.timer);
			this.$refs['reform'].resetFields();
			this.$refs['reform2'].resetFields();
			this.$refs['reform3'].resetFields();
			this.$reset('reform', ['rules']);
			this.dialogVisible = false;
		},
		//下一步
		next() {
			let that = this;
			if (that.pageInx === 1) {
				that.validate1();
				// if (that.isvalidate1) {
				// 	that.pageInx++
				// 	that.title = this.title2
				// }
			} else if (that.pageInx === 2) {
				that.validate2();
				// if (that.isvalidate2) {
				// 	that.pageInx++
				// 	that.title = that.title3
				// }
			}
		},
		validate1() {
			let that = this;

			if (!that.verifyData.success) {
				that.$emit('error', { tips: '请先完成安全验证！' });
				return;
			}

			that.$refs['reform'].validate(valid => {
				if (valid) {
					loginApi
						.getMobileByLoginName({
							username: that.reform.username,
							captcha: that.verifyData.captcha
						})
						.then(res => {
							if (res.returnCode === '1001') {
								that.isvalidate1 = true;
								that.userMobile = res.returnData.mobile;

								//进行跳页操作
								that.pageInx++;
								that.title = this.title2;
							} else {
								that.$emit('error', { tips: '您的账号不存在或已停用！' });
							}
							that.loginError();
						});
				} else {

					return false;
				}
			});
		},
		//发送请求 看是否禁用账号
		disableAccount() {
			// 如果账号状态正常
			this.isvalidate1 = true;
			// 如果账号状态不正常 //弹出提示
			//this.$emit('error',{tips:'您的账号不存在或已停用！'})
		},
		validate2() {
			let that = this;
			//判断有没有输入图形验证码
			//没有就提示需要输入图形验证码  有 就在发送手机短信后刷新验证码

			that.$refs['reform2'].validate(valid => {
				if (valid) {
					loginApi
						.checkResetPassVerify({
							verifyCode: that.reform2.valid
						})
						.then(res => {
							if (res.returnCode === '1001') {
								//进行跳页操作
								that.pageInx++;
								that.title = that.title3;
							} else {
								that.$emit('error', { tips: '验证码错误或已超时！' });
							}
						});
				} else {
					return false;
				}
			});
		},
		surefn() {
			let that = this;
			this.$refs['reform3'].validate(valid => {
				if (valid) {
					loginApi
						.restPassForBack({
							username: that.reform.username,
							password: that.reform3.pass,
							verifyCode: that.reform2.valid
						})
						.then(res => {
							if (res.returnCode === '1001') {
								that.$emit('success', { tips: '修改密码成功' });
								that.handleClose();
							} else {
								that.$emit('error', { tips: '验证码错误或已超时！' });
							}
						});
				} else {
					return false;
				}
			});
		},
		getVali() {
			if (this.stopClick) return false;
			//判断有没有输入图形验证码
			if(this.reform2.erifCode.toString().trim() == '') return that.$emit('error', { tips: '请先输入图形验证码！' });
			//发送请求验证图形验证码是否正确
			this.getValiNext()

		},
		getValiNext(){
			clearInterval(this.timer);
			this.stopClick = true;
			let that = this;
			that.second = 60;

			loginApi.sendResetPassMsg({erifCode:that.reform2.erifCode}).then(res => {
				if (res.returnCode === '1001') {
					that.canClick = false;
					that.timer = setInterval(() => {
						if (that.second === 0) {
							that.second = 60;
							clearInterval(that.timer);
							that.canClick = true;
						} else {
							that.second--;
						}
					}, 1000);
				}else if(res.returnCode === '4002'){
                    that.$emit('error', { tips: res.returnMsg });
                    this.refreshCaptcha();
				} else {
					that.$emit('error', { tips: '今日尝试次数过多，请明天再试！' });
                    this.refreshCaptcha();
				}

				this.stopClick = false;
			});
		},
		loginError: function() {
			this.verifyData.success = false;
			this.verifyData.captcha = '';
		}
	},
	watch: {
		dialogVisible: {
			handler: function(val, oldval) {
				if (val) {
					// this.$nextTick(() => {
					// 	this.$refs['slideVerification'].mountedFn();
					// })
				}
			},
			deep: true //对象内部的属性监听，也叫深度监听
		}
	}
};
</script>

<style lang="less">
.rePassword {
	.validate {
		width: 100%;
	}

	.btns {
		width: 100%;
		background-color: #0092f1;
		height: 40px;
		img {
			// width: 18px;
			margin-right: 2px;
		}
		&.el-button {
			padding: 0px;
		}
		& > span {
			width: 100%;
			height: 100%;
			display: flex;
			align-items: center;
			align-content: space-around;
			justify-content: center;
		}
	}

	.el-dialog .el-dialog__body {
		padding: 0px 100px 0px 100px;
	}

	.pageInx1 {
		padding: 64px 0px 64px 0px;
	}

	.pageInx2 {
		.phoneinfo {
			width: 214px;
			margin: 32px auto;

			font-family: MicrosoftYaHei;
			font-size: 16px;
			font-weight: normal;
			font-stretch: normal;

			letter-spacing: 0px;
			color: #666666;

			.phonenums {
				font-size: 16px;
				font-weight: normal;
				letter-spacing: 0px;
				color: #999999;
			}
		}

		.lines {
			height: 1px;
			background-color: #dde8f2;
			margin: 20px 0px;
		}

		.inputrow {
			display: flex;
			justify-content: space-between;

			.el-form-item {
				width: 200px;
			}

			.timesout {
				width: 140px;
				height: 40px;
				background-color: #ffcb78;
				border-radius: 3px;
				border: solid 1px #ffaf31;

				font-family: MicrosoftYaHei;
				font-size: 14px;
				font-weight: normal;
				font-stretch: normal;

				letter-spacing: 1px;
				color: #ffffff;
				text-align: center;
				line-height: 40px;
			}
		}

		.getVali {
			width: 140px;
			height: 40px;
			background-color: #ffa81e;
			border-radius: 3px;
			font-family: MicrosoftYaHei;
			font-size: 14px;
			font-weight: normal;
			font-stretch: normal;
			letter-spacing: 1px;
			color: #ffffff;
			float: right;
			text-align: center;
			line-height: 40px;
		}
	}
	.pageInx3 {
		padding: 52px 0px 0px 0px;
	}
	.el-dialog .el-dialog__footer {
		padding: 42px 100px 36px 100px;
	}
	.contact-number {
		margin-top: 35px;
		font-family: MicrosoftYaHei;
		font-size: 16px;
		font-weight: normal;
		font-stretch: normal;
		letter-spacing: 0px;
		color: #999999;
		span {
			font-size: 16px;
			font-weight: normal;
			letter-spacing: 0px;
			color: #e92a2a;
		}
	}
	.inputW {
		width: 199px;
	}
}
</style>
